<template>
    <error :text="'Попробуйте повторить запрос через некоторое время или обратитесь к администратору.'"
           :icon="'fa-network-wired'"
    >
        <template slot="message">
            <slot name="message">
            </slot>
        </template>
    </error>
</template>

<script>
    import Error from "./Error";

    export default {
        name: "NetworkError",
        components: {Error}
    }

</script>

<style scoped>

</style>